import { AnalyticsBrowser } from '@segment/analytics-next';
import { SegmentMock } from '@repo/poly-hooks/mocks/segment';
import type { PolymorphicSegment } from '@repo/poly-hooks/segment';
import { segmentConfig } from './environment';

export const analytics: PolymorphicSegment = !segmentConfig?.key
  ? new SegmentMock()
  : (AnalyticsBrowser.load({ writeKey: segmentConfig.key }) as PolymorphicSegment);
